import React from 'react';

/**
 * 🎨 COMPONENTE LOADING - Reutilizável
 * 
 * Spinner de carregamento flexível e reutilizável.
 * Usa TailwindCSS para estilização.
 * 
 * @param {string} size - Tamanho: 'sm' | 'md' | 'lg'
 * @param {boolean} fullScreen - Se deve ocupar tela inteira
 * @param {string} message - Mensagem exibida abaixo do spinner
 * @param {string} className - Classes CSS adicionais
 */
const Loading = ({ 
  size = 'md', 
  fullScreen = false, 
  message = 'Carregando...',
  className = ''
}) => {
  // Tamanhos do spinner
  const sizes = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-4',
    lg: 'w-12 h-12 border-4',
  };
  
  // Spinner component
  const spinner = (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      {/* Spinner animado */}
      <div 
        className={`
          ${sizes[size]}
          border-gray-200 
          border-t-primary 
          rounded-full 
          animate-spin
        `.trim().replace(/\s+/g, ' ')}
      />
      
      {/* Mensagem opcional */}
      {message && (
        <p className="mt-3 text-sm text-gray-600 animate-pulse">
          {message}
        </p>
      )}
    </div>
  );
  
  // Se for fullScreen, envolver em overlay
  if (fullScreen) {
    return (
      <div 
        className="
          fixed 
          inset-0 
          flex 
          items-center 
          justify-center 
          bg-white 
          bg-opacity-75 
          z-50
        "
        role="status"
        aria-live="polite"
        aria-label="Carregando"
      >
        {spinner}
      </div>
    );
  }
  
  return spinner;
};

/**
 * 🎨 COMPONENTE LOADING INLINE - Versão simplificada
 * 
 * Spinner pequeno para uso inline (ex: dentro de botões)
 */
export const LoadingSpinner = ({ size = 'sm', className = '' }) => {
  const sizes = {
    sm: 'w-4 h-4 border-2',
    md: 'w-5 h-5 border-2',
    lg: 'w-6 h-6 border-3',
  };
  
  return (
    <div 
      className={`
        ${sizes[size]}
        border-gray-300 
        border-t-current 
        rounded-full 
        animate-spin
        ${className}
      `.trim().replace(/\s+/g, ' ')}
      role="status"
      aria-label="Carregando"
    />
  );
};

export default Loading;

